import { styled } from 'styled-components';

export const StyledWinnerTitle = styled.div<{ $isMobile?: boolean }>`
  font-family: Atma;
  text-align: center;
  font-size: ${({ $isMobile }) => ($isMobile ? '46px' : '76px')};
  font-weight: 700;
  color: #d1aa23;
`;

export const StyledGiftContainer = styled.img`
  padding: 10px;
  max-width: 80%;
  max-height: 80%;
`;

export const StyledPrize = styled.h1`
  text-align: center;
`;
